import React from 'react';

import { OnAirScheduleBtn } from '../../styles/onAirStyles';

const OnAirSchedule = () => {
  const goSite = () => {
    window.open(process.env.PUBLIC_URL + `/schedule?tab=0`, '_blank');
  };

  return (
    <>
      <OnAirScheduleBtn onClick={goSite}>전체 편성표</OnAirScheduleBtn>
    </>
  );
};

export default OnAirSchedule;
